import React, { useContext, useEffect, useState } from 'react';
import _ from 'lodash';
import * as Yup from 'yup';

import { injectIntl } from 'react-intl';
import { Field, Form, Formik } from 'formik';
import { FormServiceContext } from 'app/utils/contexts';

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
} from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import notification from 'app/config/notification';
import { verifyLicencaNameAndFormat } from 'app/utils/forms/services/licenses';

const DialogCitySelection = (props) => {
    const { open, handleCancel, handleSave, selectedPerson } = props;

    const validationSchema = Yup.object().shape({
        deRazaoSocial: Yup.string().required('Campo obrigatório'),
    });

    const onCancel = (e, reason) => {
        if (reason && reason === 'backdropClick') return;
        if (handleCancel) handleCancel(e);
    };

    return (
        <Dialog disableEscapeKeyDown open={open} onClose={onCancel}>
            <DialogTitle>Informe os dados do passageiro</DialogTitle>
            <Formik
                enableReinitialize={true}
                initialValues={{ deRazaoSocial: '' }}
                validationSchema={validationSchema}
                validateOnBlur={false}
                validateOnChange={false}
                onSubmit={() => {}}>
                {(formProps) => {
                    const { errors } = formProps;
                    return (
                        <Form>
                            <DialogContent style={{ paddingTop: '0px', maxWidth: '350px' }}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <Field
                                            label="Nome / Razão Social"
                                            variant="filled"
                                            margin="dense"
                                            fullWidth
                                            name="deRazaoSocial"
                                            error={!!errors.deRazaoSocial}
                                            helperText={errors.deRazaoSocial ? errors.deRazaoSocial : ''}
                                            as={TextField}
                                            inputProps={{
                                                maxLength: 100,
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => handleCancel()} color="primary">
                                    Cancelar
                                </Button>
                                <Button
                                    onClick={() => {
                                        formProps.validateForm().then((res) => {
                                            if (Object.keys(res).length <= 0) {
                                                handleSave(formProps.values, selectedPerson);
                                            }
                                        });
                                    }}
                                    color="primary">
                                    Salvar
                                </Button>
                            </DialogActions>
                        </Form>
                    );
                }}
            </Formik>
        </Dialog>
    );
};

function Companies(props) {
    const { classes, data, setData, intl } = props;
    const { canEdit, errorsList, setErrorsList } = useContext(FormServiceContext);
    const [open, setOpen] = React.useState(false);
    const [selectedPerson, setSelectedPerson] = useState(null);

    const [filteredCollectionData, setFilteredCollectionData] = useState({
        dataBoExcluido: [],
        dataBoNotExcluido: [],
    });

    useEffect(() => {
        const init = () => {
            const temp = _.cloneDeep(data);
            const dataBoExcluido = temp.filter((c) => c.boExcluido);
            const dataBoNotExcluido = temp.filter((c) => !c.boExcluido);
            setFilteredCollectionData({
                dataBoExcluido,
                dataBoNotExcluido,
            });
        };
        init();
    }, [data]);

    const changeElement = async (index) => {
        let temp = [...data];
        if (index === undefined) {
            handleClickOpen(temp.length);
        } else {
            if (window.confirm('Deseja excluir este item?')) {
                temp = verifyLicencaNameAndFormat({ filteredCollectionData, index, cdLicencaName: 'cdLicencaEmpresa' });
            }
        }
        setData(temp);
    };

    const handleClickOpen = (index) => {
        setSelectedPerson(index);
        setOpen(true);
    };

    const handleCancel = () => {
        setSelectedPerson(null);
        setOpen(false);
    };

    const onChangeField = (person) => {
        let temp = _.cloneDeep(data);

        const { dataBoExcluido, dataBoNotExcluido } = filteredCollectionData;
        const indexLastCompany = dataBoNotExcluido.length - 1;
        const foundOnList = _.find(dataBoNotExcluido, function (o) {
            return o.deRazaoSocial === person.deRazaoSocial;
        });

        if (foundOnList) {
            notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.ELEMENT_ALREADY_EXISTS' }), {
                toastId: 'ELEMENT_ALREADY_EXISTS',
                type: 'warning',
            });
            return false;
        }

        dataBoNotExcluido[indexLastCompany + 1] = person;

        if (errorsList && errorsList.companies) {
            const errorsTemp = { ...errorsList };
            delete errorsTemp.companies;

            setErrorsList(errorsTemp);
        }

        temp = [...dataBoNotExcluido, ...dataBoExcluido];

        setData(temp);
        handleCancel();
        return true;
    };

    return (
        <>
            <DialogCitySelection
                {...props}
                selectedPerson={selectedPerson}
                open={open}
                handleCancel={handleCancel}
                handleSave={onChangeField}
                classes={classes}
            />

            <Grid item xs={12}>
                <h3 className={classes.titleTable}>Lista de empresa(s) contratante(s) / orgão(s)</h3>
                <Table className={errorsList?.companies ? classes.tableError : classes.table}>
                    <TableHead>
                        <TableRow className={classes.tableRow}>
                            <TableCell className={classes.headTableCell} align="left">
                                Nome / Razão Social
                            </TableCell>
                            {canEdit && (
                                <TableCell className={classes.headTableCell} align="center">
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disableElevation
                                        onClick={() => changeElement()}
                                        className={classes.addButton}>
                                        <AddIcon /> Adicionar
                                    </Button>
                                </TableCell>
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredCollectionData.dataBoNotExcluido.map((row, indexRow) => (
                            <TableRow key={`irr-row-${indexRow}`} className={classes.tableRow}>
                                <TableCell align="left">{row.deRazaoSocial || ''}</TableCell>
                                {canEdit && (
                                    <TableCell align="right">
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => changeElement(indexRow)}
                                            className={classes.btnSigleAction}
                                            size="small">
                                            <DeleteIcon fontSize="inherit" />
                                        </Button>
                                    </TableCell>
                                )}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Grid>
        </>
    );
}

export default injectIntl(Companies);
